import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { getStickerSets } from '../../../../store/common/actions'
import { getAllUserGroupOptions } from '../../../../store/notifications/actions'
import {
  getAllButtonOptions,
  getAllIntents,
  getAllUserGroups,
} from '../../../../store/questions/actions'
import '../../index.scss'
import DashboardNavigation from '../DashboardNavigation'
import Ratings from '../../pages/partials/Ratings/Ratings'
import UserFeedback from '../reports/UserFeedback'

import { useTranslation } from 'react-i18next'
import { DashboardFilters } from '../../../../components/UI/Dashboard'

const MatchedUnmatchedQuestions = (props: any) => {
  const { t } = useTranslation('translation')
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getAllUserGroups())
    dispatch(getStickerSets())
    dispatch(getAllUserGroupOptions())
    dispatch(getAllButtonOptions())
    dispatch(getAllIntents())
  }, [props.location.state])

  return (
    <section className="dashborad-wraper">
      <DashboardFilters showFilter={false} hasFilterUpdated={() => {}} />
      <DashboardNavigation />

      <div className="tw-pt-4 tw-flex tw-flex-col tw-gap-4">
        <Ratings />

        <UserFeedback />
      </div>
    </section>
  )
}

export default MatchedUnmatchedQuestions
